module.exports = __webpack_public_path__ + "static/media/study 201019.a0c87030.png";